import { Component, OnInit } from '@angular/core';
import { AbstractCallComponent } from '../abstract-call/abstract-call.component';

@Component({
    selector: 'se-array-find-call',
    template: '',
    standalone: true,
})
export class ArrayFindCallComponent extends AbstractCallComponent implements OnInit {
    ngOnInit(): void {
        super.ngOnInit();
        this.callInit();
    }

    protected async run(): Promise<any> {
        let parsedCall = this.parseAllSourceWithDataStore(this.call);
        parsedCall = this.applyPostParseProcessing({ ...this.call, ...parsedCall });

        if (!parsedCall.findConfig) {
            this.callThrowError.emit('findConfig is required in call configuration');
            return;
        }

        const { keyPathToSearch, valueToMatch, arrayToSearchIn } = parsedCall.findConfig;

        if (this.debug) {
            console.log('INTEGRATIONS arrayFind run()', { parsedCall });
        }

        if (!Array.isArray(arrayToSearchIn)) {
            this.callThrowError.emit(this.call.errorHandling?.action);
            return Promise.reject(new Error('arrayToSearchIn must be an array'));
        } else {
            const valueFound =
                arrayToSearchIn.find((entry) =>
                    keyPathToSearch ? entry[keyPathToSearch] == valueToMatch : entry == valueToMatch,
                ) ?? null;

            if (this.debug) {
                console.log('INTEGRATIONS arrayFind run()', { valueFound });
            }

            return Promise.resolve(valueFound);
        }
    }

    protected end() {
        if (this.errorValueHandler(this.getValueStoreDataFromPath())) {
            this.callThrowError.emit(this.call.errorHandling?.message ?? 'No result found');
        } else {
            super.end();
        }
    }
}
